import React from "react"
import {
    Button,
    Dialog,
    DialogContent,
    DialogActions,
    styled,
} from "@mui/material"
import { COLORS } from "../utils"

const StyledDialog = styled(Dialog)({
    "& .MuiPaper-root": {
        width: 500,
    },
})

const DeleteConfirmationModal = ({
    onClose,
    open,
    onConfirm,
    description
}) => {
    return (
        <StyledDialog
            open={open}
            onClose={onClose}
            aria-labelledby="form-dialog-title"
        >
            <DialogContent sx={{ color: COLORS.DRAFT_GREY, fontSize: 16 }}>
                {description}
            </DialogContent>
            <DialogActions sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 2 }}>
                <Button onClick={onClose} color="primary">
                    Retour
                </Button>
                <Button onClick={onConfirm} color="primary">
                    Confirmer
                </Button>
            </DialogActions>
        </StyledDialog>
    )
}

export default DeleteConfirmationModal
